// extracted by mini-css-extract-plugin
export default {"card":"uba-z","carousel":"vba-z"};